import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Bell } from "@phosphor-icons/react";
import { useState } from "react";
import { useLeadCapture } from "@/hooks/useLeadCapture";
import { toast } from "sonner";

export function BlogAlertSubscription() {
  const [email, setEmail] = useState("");
  const { captureQuickLead, isSubmitting } = useLeadCapture();

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !email.includes("@")) {
      toast.error("Te rugăm să introduci o adresă de email validă");
      return;
    }

    const success = await captureQuickLead(
      email,
      "blog_alert_subscription",
      "general"
    );

    if (success) {
      setEmail("");
      toast.success("Te-ai abonat cu succes! Vei primi alerte despre mașini noi.");
    }
  };

  return (
    <Card className="bg-gradient-to-br from-primary/10 via-primary/5 to-background border-primary/20">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-xl font-playfair">
          <Bell className="text-primary" size={24} />
          Înscrie-te la Alerte Email
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-4">
          🔔 Primești notificări când apar mașini noi care te interesează. Setează criterii personalizate și fii primul care vede ofertele.
        </p>
        <form onSubmit={handleSubscribe} className="space-y-3">
          <Input
            type="email"
            placeholder="adresa@email.ro"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-background"
            required
            disabled={isSubmitting}
          />
          <Button 
            type="submit" 
            className="w-full" 
            disabled={isSubmitting}
          >
            {isSubmitting ? "Se procesează..." : "Activează Alertele Gratuit"}
          </Button>
          <p className="text-xs text-muted-foreground text-center">
            ✓ Fără spam • ✓ Anulezi oricând • ✓ 100% gratuit
          </p>
        </form>
      </CardContent>
    </Card>
  );
}
